import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyTable } from '../features/campaigns/supply/components/TailoredSupplyTable';
import { supplyRouteSearchSchema } from '../features/campaigns/supply/supplyRouteSearch';
import { SupplyTabs } from '../features/campaigns/supply/SupplyTabs';

export const Route = createFileRoute('/campaigns/supply/tailored-supply/')({
  validateSearch: supplyRouteSearchSchema,
  component: TailoredSupplyIndexPage,
});

function TailoredSupplyIndexPage() {
  return (
    <>
      <SupplyTabs />
      <main className="min-w-0 px-4 py-6 sm:px-6 lg:px-8">
        <TailoredSupplyTable />
      </main>
    </>
  );
}
